import React from "react";
import { connect } from "react-redux";
import { createCompany } from "actions/company";
import logo from "assets/logo.jpg";
import PropTypes from "prop-types";

import Card, { CardBlock } from "components/Card";
import history from "utils/history";
import Translate from "utils/translate";
import { getUrlParams } from "utils/urlParams";

import { CompanyForm } from ".";

import styles from "../../SignUp.css";

const { t } = new Translate("SignUp");

const ExistingCompany = ({ onCreateCompany }) => (
  <Card className={styles.container}>
    <CardBlock>
      <img alt="" src={logo} width="195" />
    </CardBlock>
    <CardBlock>
      <p>{t("company.details")}</p>
    </CardBlock>
    <CardBlock>
      <CompanyForm onSubmit={onCreateCompany} />
    </CardBlock>
  </Card>
);

ExistingCompany.propTypes = {
  onCreateCompany: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onCreateCompany: (company) => {
    const [role, type] = company.role.split("_");
    const { plan } = getUrlParams();

    return dispatch(
      createCompany(
        {
          ...company,
          countryId: company.country.id,
          type,
          role,
        },
        plan
      )
    ).then(() => history.push("/"));
  },
});

export default connect(null, mapDispatchToProps)(ExistingCompany);
